import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "sorting-buttons__container q-col-12 q-col-md-6 q-col-xl-3 q-p-0 q-p-sm-1"
}

import SortingButton from "@/components/SerpPage/ResultsContainer/ButtonsContainer/SortingButton.vue";
import {useSerpResultsStore} from "@/store/SerpPage/SerpResultsStore";
import {storeToRefs} from "pinia";

export default /*@__PURE__*/_defineComponent({
  __name: 'SortingButtonContainer',
  setup(__props) {

const serpStore = useSerpResultsStore();
const { noResultsState} = storeToRefs(serpStore)

return (_ctx: any,_cache: any) => {
  return (!_unref(noResultsState))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(SortingButton)
      ]))
    : _createCommentVNode("", true)
}
}

})